export const ICONS_ALIASES = {
  archive: 'archive',
  arrowLeft: 'arrowLeft',
  arrowSquareLeft: 'arrowSquareLeft',
  arrowTwoToneLeft: 'arrowTwoToneLeft',
  arrowRight: 'arrowRight',
  arrowSquareRight: 'arrowSquareRight',
  arrowDown: 'arrowDown',
  arrowUp: 'arrowUp',
  arrowUpMain: 'arrowUpMain',
  callCalling: 'callCalling',
  chevronUp: 'chevronUp',
  chevronDown: 'chevronDown',
  check: 'check',
  checkRounded: 'checkRounded',
  close: 'close',
  clock: 'clock',
  coin: 'coin',
  document: 'document',
  deviceMessage: 'deviceMessage',
  edit: 'edit',
  link: 'link',
  lock: 'lock',
  messageText: 'messageText',
  minus: 'minus',
  more: 'more',
  people: 'people',
  plus: 'plus',
  phone: 'phone',
  saveAdd: 'saveAdd',
  search: 'search',
  searchNormal: 'searchNormal',
  searchZoomIn: 'searchZoomIn',
  send: 'send',
  shield: 'shield',
  shieldTick: 'shieldTick',
  sms: 'sms',
  smsEdit: 'smsEdit',
  step: 'step',
  stepDone: 'stepDone',
  radioOn: 'radioOn',
  radioOff: 'radioOff',
  facebook: 'facebook',
  linkedin: 'linkedin',
  trash: 'trash',
  twitter: 'twitter',
  upload: 'upload',
  popular: 'popular',
  recommend: 'recommend',
  tick: 'tick',
};
